import { Component, input, Input } from "@angular/core";

@Component({
  selector: "snt-async-button",
  templateUrl: "async-button.component.html",
  styles: `
    :host {
      display: flex;
    }
  `,
  standalone: false
})
export class AsyncButtonComponent {
  @Input()
  icon: string = "";

  @Input()
  title: string = "";

  @Input()
  type: "primary" | "default" | "text" = "default";

  @Input()
  disabled: boolean = false;

  @Input()
  small: boolean = false;

  @Input()
  onClick: (() => Promise<any>) | undefined;

  @Input()
  trackEvent: string | undefined;

  flex = input<boolean>(false);

  loading = false;

  async click(): Promise<void> {
    try {
      this.loading = true;
      if (this.onClick) {
        await this.onClick.apply(this.onClick);
      }
    } catch (e) {
    } finally {
      this.loading = false;
    }
  }
}
